














import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/auth';

@Component
export default class UiSelectGeoAreas extends BaseComponent {
  @Prop()
  value: any;

  selected: any = null;

  loading = false;
  list = [];

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.selected = v;
  }

  mounted() {
    this.load();
  }

  load() {
    this.loading = true;
    service.listGeoAreasAccess().subscribe(
      (res) => {
        this.list = res;
        this.loading = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }

  onChange() {
    this.$emit('input', this.selected);
    this.$emit('change', this.selected);
  }
}
